import Vue from 'vue'
import { authenticate, me, completeLearningNewFeatures } from '@/backend/auth'
import { getAccessToken,
  setAccessToken,
  removeAccessToken,
  setCurrentEntityId as setLocalStorageEntityId,
  getCurrentEntityId,
  removeCurrentEntityId } from '@/backend/storage'

import { checkRoleManager } from '@/helpers/roles';

export const NOT_DISTURB_STATUS = {
  on: 'on',
  middle: 'middle',
  off: 'off'
}
const SIGNIN = "SIGNIN";
const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
const SIGNOUT = "SIGNOUT";
const SET_USER = 'SET_USER';
const SET_NOT_DISTURB_STATUS = 'SET_NOT_DISTURB_STATUS';
const SET_CHECK_SHOW_POPUP_FEATURE = 'SET_CHECK_SHOW_POPUP_FEATURE';
const SET_CURRENT_ENTITY_ID = 'SET_CURRENT_ENTITY_ID';
const COMPLETE_LEARNING_NEW_FEATURES = 'COMPLETE_LEARNING_NEW_FEATURES';

const state = {
  isLoggedIn: !!getAccessToken(),
  accessToken: getAccessToken(),
  currentUser: { entities: [], hubs: [] },
  notDisturbStatus: NOT_DISTURB_STATUS.off,
  needToCheckShowPopupNewFeatures: false,
  currentEntityId: null,
  singleEntity: false
}

export const getters = {
  isLoggedIn: state => {
    return state.isLoggedIn
  },
  accessToken: state => {
    return state.accessToken
  },
  currentUser: state => {
    return state.currentUser
  },
  firstName: state => {
    return state.currentUser.first_name
  },
  lastName: state => {
    return state.currentUser.last_name
  },
  services: state => {
    return state.currentUser.services
  },
  entities: state => {
    return state.currentUser.entities
  },
  currentEntityId: state => {
    return state.currentEntityId
  },
  notDisturbStatus: state => {
    return state.notDisturbStatus
  },
  needToCheckShowPopupNewFeatures: state => {
    return state.needToCheckShowPopupNewFeatures
  },
  isSingleEntity: state => {
    return state.singleEntity
  }
}

export const mutations = {
  [SIGNIN] (state) {
    state.pending = true;
  },
  [SIGNIN_SUCCESS] (state, accessToken) {
    state.isLoggedIn = true;
    state.pending = false;
    state.accessToken = accessToken;
  },
  [SIGNOUT] (state) {
    state.isLoggedIn = false;
    state.accessToken = "";
    removeCurrentEntityId();
    state.currentUser = {};
  },
  [SET_USER] (state, user) {
    state.currentUser = user
    state.currentUser.isManager = checkRoleManager(user.role)
    if (user.entities) {
      state.singleEntity = (user.entities.length == 1)
    }
  },
  [SET_NOT_DISTURB_STATUS] (state, value) {
    state.notDisturbStatus = value
  },
  [SET_CHECK_SHOW_POPUP_FEATURE] (state, value) {
    state.needToCheckShowPopupNewFeatures = value
  },
  [SET_CURRENT_ENTITY_ID] (state, value) {
    state.currentEntityId = value
  },
  [COMPLETE_LEARNING_NEW_FEATURES] (state, value) {
    state.currentUser.should_learn_new_features = value
  },
}

export const actions = {
  signIn({ commit }, credentials) {
    commit(SIGNIN);
    return authenticate(credentials.email, credentials.password).then( (response) => {
      commit(SIGNIN_SUCCESS, response.data.access_token);
      setAccessToken(credentials.rememberMe, response.data.access_token);
    })
  },

  signOut({ commit }) {
    removeAccessToken();
    commit(SIGNOUT);
  },

  getUser({ commit }, user) {
    return me().then( (response) => {
      commit(SET_USER, response.data);
      return Promise.resolve(response.data);
    }).catch((error) => {
      return Promise.reject(error);
    });
  },

  signInAferResetPassword( {commit}, access_token) {
    commit(SIGNIN_SUCCESS, access_token);
    setAccessToken(true, access_token);
  },

  setUser({ commit }, user) {
    commit(SET_USER, user)
  },

  setNotDisturbStatus({ commit }, value) {
    commit(SET_NOT_DISTURB_STATUS, value);
  },

  setCheckShowPopupFeature({ commit }, value) {
    commit(SET_CHECK_SHOW_POPUP_FEATURE, value);
  },

  setCurrentEntityId({ commit }, value) {
    commit(SET_CURRENT_ENTITY_ID, value);
    setLocalStorageEntityId(value);
  },

  initCurrentEntityId({ commit }) {
    var currentEntityId = null;
    if (state.currentUser.entities.length == 1) {
      currentEntityId = state.currentUser.entities[0].id;
    } else {
      currentEntityId = getCurrentEntityId();
    }
    commit(SET_CURRENT_ENTITY_ID, currentEntityId);
  },

  completeLearningNewFeatures({ commit }) {
    return completeLearningNewFeatures().then((response) => {
      commit(COMPLETE_LEARNING_NEW_FEATURES, response.data);
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js